import React from 'react';
import PodcastBase from './PodcastBase';
import { Field } from '@sitecore-jss/sitecore-jss-nextjs';

type PodcastProps = {
  fields: {
    url?: Field<string>;
    title?: Field<string>;
  };
};

const Podcast: React.FC<PodcastProps> = ({ fields }) => {
  const src = fields.url?.value;
  const title = fields.title?.value;

  const iframeSrc = `https://www.buzzsprout.com/${src}?client_source=small_player&iframe=true`;

  return (
    <PodcastBase fields={fields}>
      <iframe src={iframeSrc} loading="lazy" width="100%" height="200" title={title} />
    </PodcastBase>
  );
};

export default Podcast;
